var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame28(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5816 11.3455L4.74585 2.47746C4.61262 2.40285 4.4598 2.37069 4.30781 2.38526C4.15582 2.39983 4.0119 2.46045 3.89528 2.55901C3.77866 2.65757 3.6949 2.78938 3.65519 2.93681C3.61549 3.08425 3.62173 3.24029 3.67309 3.38409L6.66006 11.7476C6.71832 11.9107 6.71832 12.089 6.66006 12.2521L3.67309 20.6156C3.62173 20.7594 3.61549 20.9155 3.65519 21.0629C3.6949 21.2104 3.77866 21.3422 3.89528 21.4407C4.0119 21.5393 4.15582 21.5999 4.30781 21.6145C4.45981 21.629 4.61263 21.5969 4.74585 21.5223L20.5816 12.6542C20.6979 12.5891 20.7948 12.4941 20.8622 12.3791C20.9296 12.2641 20.9652 12.1332 20.9652 11.9999C20.9652 11.8665 20.9296 11.7356 20.8622 11.6206C20.7948 11.5056 20.6979 11.4106 20.5816 11.3455V11.3455Z",
    stroke: "#121212",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12H12.75",
    stroke: "#121212",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame28);
export default __webpack_public_path__ + "static/media/Frame 28.081fea8c.svg";
export { ForwardRef as ReactComponent };